import { forwardRef, type Ref, type SVGProps } from "react";
const IconMegaphoneFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="m18.362 3.11 1.613-.82a1.81 1.81 0 0 1 2.434.79l7.396 14.515c.45.89.096 1.978-.792 2.434l-1.613.82c-.89.45-1.978.096-2.434-.792l-.106-.21-8.505 1.55-1.064.542.906 1.044c.313.36.412.857.262 1.31l-.15.481.666.769a2.633 2.633 0 0 1-.79 4.069 2.71 2.71 0 0 1-3.28-.635l-3.507-4.033-.984.502a2.716 2.716 0 0 1-3.651-1.187l-2.465-4.837a2.71 2.71 0 0 1 1.186-3.652l7.942-4.046 6.248-5.979-.103-.201a1.81 1.81 0 0 1 .791-2.435m-3.38 16.651a.373.373 0 0 0 .461.181l1.013-.374a.373.373 0 0 0 .202-.52l-3.122-6.104a.373.373 0 0 0-.54-.14l-.88.595a.373.373 0 0 0-.124.477zm13.32-1.768a.373.373 0 0 1-.163.502l-.949.482a.373.373 0 0 1-.5-.163l-7.057-13.85a.373.373 0 0 1 .163-.502l.948-.482a.373.373 0 0 1 .501.163zm-13.21 10.13a.652.652 0 1 0 0-1.304.652.652 0 0 0 0 1.304"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMegaphoneFilledSVG);
ForwardRef.displayName = "IconMegaphoneFilled";
export { ForwardRef as IconMegaphoneFilled };
